<script lang="ts" setup>
    defineProps<{
        image: Pick<StoryblokAsset, 'filename' | 'alt'>;
        to: string;
    }>();

    defineEmits<{
        click: [];
    }>();

    const { t } = useI18n();
</script>

<template>
    <div class="logo">
        <NuxtLink
            :to="to"
            :aria-label="t('languagePicker.toHome')"
            @click="$emit('click')"
            @keydown.enter="$emit('click')"
        >
            <span class="sr-only">{{ t('languagePicker.toHome') }}</span>
            <img
                :src="image.filename || ''"
                aria-hidden="true"
                class="medice-logo"
            />
        </NuxtLink>
    </div>
</template>

<style lang="scss" scoped>
    .logo {
        align-items: center;
        align-self: center;
        display: flex;
        transition: opacity 0.3s $anim-ease-bounce;

        :deep(a) {
            display: block;
        }

        .medice-logo {
            height: 24px;
            transition: transform $anim-duration-hover $anim-ease-bounce;
            transform-origin: bottom;
            width: auto;

            &:hover {
                transform: $anim-scale-hover;
            }

            @media (min-width: $br-xs) {
                height: 32px;
            }

            @include header-desktop {
                height: 42px;
            }
        }
    }
</style>
